<template>
    <div class="fixed inset-0 z-50 bg-white flex items-center justify-center">
        <div class="bg-white rounded-lg shadow-xl max-w-[440px] w-full mx-4 p-10">
            <div class="flex justify-center w-full">
                <svg width="84" height="48" viewBox="0 0 84 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M57.2803 3.55099C58.4059 3.55099 58.8845 4.92202 58.3385 6.67009C57.7926 8.41817 56.4512 9.7892 55.3256 9.7892C54.1999 9.7892 53.7213 8.41817 54.2673 6.67009C54.7998 4.94944 56.1546 3.55099 57.2803 3.55099ZM65.5171 20.3051C64.5532 20.2159 64.2432 18.8038 64.7824 17.1928C65.3216 15.5818 66.5147 14.3548 67.4786 14.4507C68.4425 14.5467 68.7525 15.952 68.2133 17.563C67.6808 19.1739 66.481 20.3942 65.5171 20.3051ZM29.3074 17.563C28.7682 19.1739 27.5684 20.3942 26.6113 20.3051C25.6541 20.2159 25.3373 18.8038 25.8766 17.1928C26.4158 15.5818 27.6089 14.3548 28.5727 14.4507C29.5366 14.5467 29.8467 15.952 29.3142 17.563M8.37837 39.3488C6.57867 42.5638 5.00815 44.4764 4.46217 44.4764C4.07797 44.4764 3.74769 43.4413 3.74769 42.1525C3.74769 37.4636 6.60564 30.4507 10.1241 23.6435C10.8993 25.0488 11.27 27.0711 11.27 29.8612C11.27 32.4387 10.1983 36.1405 8.37837 39.383M82.2267 11.8869C81.0296 13.6564 79.6759 15.3109 78.1824 16.8295C76.5175 18.557 74.5493 20.0583 73.0192 20.0583C72.6013 20.0583 72.1362 19.9075 72.1362 18.5433C72.238 16.9458 72.6026 15.3771 73.2147 13.9023C73.2147 13.9023 72.3654 13.6075 70.6668 12.9015C69.7826 11.8814 68.5188 11.2847 67.182 11.2562C65.2713 11.2954 63.4905 12.248 62.3761 13.8269C61.547 14.8963 60.9336 15.7532 60.4348 16.3907C58.8576 18.4473 56.7141 20.0651 55.0425 20.0651C54.6227 20.0853 54.2158 19.9147 53.9319 19.5995C53.648 19.2843 53.5165 18.8571 53.573 18.4336C53.7052 17.464 53.9496 16.5137 54.301 15.6024C54.7998 13.8475 54.1864 12.6547 52.1845 12.3256C49.8254 16.1988 48.1402 20.0651 45.0059 20.0651C43.6916 20.0651 42.6872 19.126 42.6872 17.3231C42.6872 13.6624 46.0574 8.65124 48.4301 4.88775C50.3983 1.72065 48.8345 0.452442 47.5066 0C47.1157 0.548415 43.2669 6.44387 40.9886 9.6521C39.0946 12.3325 34.7537 13.635 32.3541 13.7241C31.536 12.2261 29.9945 11.2854 28.3099 11.2562C25.0879 11.2562 23.5039 13.8338 23.0321 14.485C22.5603 15.1362 21.5627 16.425 21.4548 16.5416C18.6912 19.9143 17.2218 20.024 16.0625 20.024C14.8453 19.9425 13.6529 19.6358 12.544 19.1191C15.712 13.4636 19.0418 8.31534 21.0234 5.18938C22.9108 2.21423 21.6975 0.507284 19.9585 0.0137103C19.399 0.829477 14.0808 8.49357 8.97153 17.7481L5.66871 16.5073C5.66871 16.5073 3.89598 19.7018 6.22143 20.8192C6.32928 20.8809 6.50453 20.9632 6.74044 21.0797L7.11791 21.2648C3.24215 28.7575 0 36.6684 0 42.1525C0 46.1902 2.06932 48 4.11841 48C5.4665 48 8.16268 47.1362 11.452 41.3847C13.6831 37.4773 14.9638 33.1585 14.9638 29.8269C14.9253 27.5745 14.5128 25.3449 13.7438 23.2322C14.3365 23.3736 14.9417 23.454 15.5502 23.4721C17.997 23.5818 20.1135 23.1294 22.5063 20.1885C23.1356 22.1134 24.8869 23.4279 26.8809 23.4721C30.6825 23.4721 33.0551 19.5853 33.0551 17.3916C35.4961 17.0509 37.8226 16.1251 39.8428 14.6907C39.5758 15.4387 39.4301 16.2259 39.4114 17.0214C39.4114 21.2648 41.8986 23.4653 44.9857 23.4653C47.2822 23.4051 49.4087 22.2204 50.6949 20.2845C50.6949 21.9572 51.9621 23.4653 54.8335 23.4653H55.3862C55.6087 23.4653 55.7704 23.4242 55.9389 23.4036L56.4445 23.2939C56.7626 23.213 57.0755 23.1123 57.3814 22.9923C58.4914 22.5325 59.5274 21.9064 60.455 21.1345C60.7921 20.8672 61.1291 20.5793 61.4324 20.2913C62.0798 22.1512 63.7805 23.4186 65.7193 23.4859C67.2762 23.3917 68.7167 22.6167 69.6692 21.3608C70.2042 22.6704 71.477 23.5098 72.8709 23.4721C77.387 23.4721 82.4491 16.7678 83.3119 15.5681C84.1747 14.3685 84.6128 12.5107 82.2267 11.9075"
                        fill="#F04E23" />
                </svg>

            </div>
            <div class="flex flex-col items-center text-center">
                <h1 class="text-xl font-semibold text-gray-800">Account is scheduled for deletion</h1>
                <p class="mt-3 text-sm text-gray-500 p-2">
                    Your account is no longer accessible. All account data will be permanently deleted from our system within
                    <span class="font-bold text-gray-500"> 30 days.</span>
                </p>
            </div>
            <div class="mt-4 text-sm bg-gray-50 p-6 text-gray-500 text-center rounded-lg">
                Changed your mind? Contact
                <a href="mailto:help@folia.com" class="text-blue-600 underline">help@folia.com </a>
                to cancel this request.
            </div>

            <div class="mt-6 flex flex-col justify-end gap-3">
                <button @click="goHome" class="px-4 py-2 rounded-md bg-orange-500 text-white">Go to Folia home
                    page</button>
                <button @click="loginOther" class="px-4 py-2 rounded-md bg-white border border-gray-200 text-gray-800">Login with other
                    accounts</button>
            </div>
        </div>
    </div>
</template>

<script>
import { inject } from 'vue';
import { useRouter } from 'vue-router';

export default {
    name: 'AccountDeletionConfirmedScreen',
    setup() {
        const $auth0 = inject('$auth0');
        const router = useRouter();

        const goHome = async () => {
            try {
                window.location.href = 'https://www.folia.com';
            } catch (e) {
                console.warn('auth0 signOut failed', e);
            } finally {

            }
        };

        const loginOther = async () => {
            try {
                if ($auth0 && $auth0.signOut) {
                    await $auth0.signOut();
                }
                // after sign out, redirect to login flow
                if ($auth0 && $auth0.signIn) {
                    await $auth0.signIn();
                } else {
                    router.push({ name: 'home' }).catch(() => { window.location.href = '/'; });
                }
            } catch (e) {
                console.warn('loginOther flow failed', e);
                try { localStorage.clear(); } catch (err) { }
                router.push({ name: 'home' }).catch(() => { window.location.href = '/'; });
            }
        };

        return { goHome, loginOther };
    }
};
</script>

<style scoped>
/* Ensure this view blocks interaction */
.no-scroll {
    overflow: hidden;
}
</style>
